const config = {
   defaultTitle: ' - A. Biedermann'
}

export default config;